import React, { memo } from 'react'
import { Stack } from '@mui/material'
import { Trans } from 'react-i18next'

import NotificationContainer from './containers/NotificationContainer'
import Text from './components/shared/text/Text'
import { buildNotifications } from './util/points-bonuses.helpers'

const Notifications = ({ t, mainProfile }) => {
  const alerts = buildNotifications(mainProfile, t)
  return (
    alerts.length && (
      <NotificationContainer
        messages={
          <Stack spacing={0.5}>
            {alerts.map(({ value, label }, index) => (
              <Text
                key={index}
                fontSize='1rem'
                label={
                  <Trans
                    i18nKey='notification.you-received-bonus'
                    values={{ points: value, message: label }}
                  />
                }
              />
            ))}
          </Stack>
        }
      />
    )
  )
}

export default memo(Notifications)
